<template>
  <a-drawer
    title="UC 编辑信息"
    width="600"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="touchCancel"
  >
    <a-spin :spinning="isDetailLoading">
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 分类 -->
      <a-form-item label="分类" name="uc_type" :rules="[{ required: true, message: '请选择分类' }]">
        <a-select
          v-model:value="formState.uc_type"
          placeholder="请选择"
          allow-clear
          :getPopupContainer="(t) => t.parentNode"
        >
          <a-select-option v-for="item in UcCategory" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 主线 -->
      <a-form-item label="主线" name="uc_tag" :rules="[{ required: true, message: '请选择主线' }]">
        <a-select
          v-model:value="formState.uc_tag"
          placeholder="请选择"
          allow-clear
          :getPopupContainer="(t) => t.parentNode"
        >
          <a-select-option v-for="item in UcZhuxianTags" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 角色 -->
      <a-form-item label="角色" name="uc_role_tag" :rules="[{ required: true, message: '请选择角色' }]">
        <a-select
          v-model:value="formState.uc_role_tag"
          placeholder="请选择"
          allow-clear
          :getPopupContainer="(t) => t.parentNode"
        >
          <a-select-option v-for="item in UcJueseTags" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 情节 -->
      <a-form-item label="情节" name="uc_plot_tag" :rules="[{ required: true, message: '请选择情节' }]">
        <a-select
          v-model:value="formState.uc_plot_tag"
          placeholder="请选择"
          allow-clear
          :getPopupContainer="(t) => t.parentNode"
        >
          <a-select-option v-for="item in UcQingjieTags" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 风格 -->
      <a-form-item label="风格" name="uc_style_tag" :rules="[{ required: true, message: '请选择风格' }]">
        <a-select
          v-model:value="formState.uc_style_tag"
          placeholder="请选择"
          allow-clear
          :getPopupContainer="(t) => t.parentNode"
        >
          <a-select-option v-for="item in UcFenggeTags" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 是否免费 -->
      <a-form-item label="是否免费" name="uc_is_free" :rules="[{ required: true, message: '请选择是否免费' }]">
        <a-radio-group v-model:value="formState.uc_is_free">
          <a-radio v-for="item in UcIsFreeOptions" :key="item.value" :value="item.value">{{ item.text }}</a-radio>
        </a-radio-group>
      </a-form-item>
      <!-- UC 定时任务 -->
      <a-form-item label="定时发布" name="uc_publish" :rules="[{ required: true, message: '请选择定时发布' }]">
        <a-radio-group v-model:value="formState.uc_publish">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <!-- 版权证明文件 -->
      <a-form-item label="版权证明文件" name="uc_copyright_certificate_list" :rules="[{ required: true, validator: validatorCertificate }]">
        <a-form-item-rest>
          <Upload
            accept=".pdf,.jpg,.jpeg,.png"
            uploadSource="UcCopyright"
            :multiple="true"
            :uploadResult="(fileJson) => uploadResult(fileJson)"
            :fileList="formState.uc_copyright_certificate_list"
            :uploadBucket="$pub.BUCKET_PUB()"
          />
        </a-form-item-rest>
        <div style="color: #8c8c8c; font-size: 12px; margin-top: 4px;">确保上传的资料完整性，支持 pdf、jpg 等格式，文件大小请控制在 100MB 以内</div>
        <div v-if="formState.uc_copyright_certificate_list.length" style="margin-top: 8px;">
          <div
            v-for="(item, index) in formState.uc_copyright_certificate_list"
            :key="item.uid || index"
            style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px; font-size: 13px;"
          >
            <PaperClipOutlined style="color: #8c8c8c;" />
            <a
              v-if="item.url"
              :href="item.url"
              target="_blank"
              style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
            >{{ item.name || item.url }}</a>
            <span v-else style="flex: 1; color: #8c8c8c;">{{ item.name }}（上传中...）</span>
            <a style="color: #ff4d4f; flex-shrink: 0;" @click="touchDeleteFile(index)">删除</a>
          </div>
        </div>
      </a-form-item>
    </a-form>
    </a-spin>
    <!-- footer -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="touchCancel">取消</a-button>
      <a-button type="primary" :loading="isLoading" @click="touchOk">保存</a-button>
    </template>
  </a-drawer>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import { PaperClipOutlined } from '@ant-design/icons-vue'
import Upload from '@/components/Upload'
import { thirdDramaDetail, ucSave } from '@/api/copyright'
import {
  UcIsFreeOptions,
  UcCategory,
  UcZhuxianTags,
  UcJueseTags,
  UcQingjieTags,
  UcFenggeTags
} from '@/utils/constantFilmLibrary'

const emit = defineEmits(['success'])

// ========================= Refs =========================
const RefForm = ref(null)
const visible = ref(false)
const isLoading = ref(false)
const isDetailLoading = ref(false)

// 当前记录
let currentRecord = null

// 表单
const formState = reactive({
  uc_type: undefined,
  uc_tag: undefined,
  uc_role_tag: undefined,
  uc_plot_tag: undefined,
  uc_style_tag: undefined,
  uc_is_free: undefined,
  uc_publish: 0,
  uc_copyright_certificate_list: []
})

// ========================= 工具函数 =========================
function urlsToFileList(urls) {
  if (!urls || !Array.isArray(urls)) return []
  return urls.filter(Boolean).map((url, i) => ({
    uid: `saved-${i}-${url}`,
    name: url.split('/').pop() || `file-${i}`,
    status: 'done',
    url
  }))
}

function resetForm() {
  RefForm.value?.resetFields()
  formState.uc_type = undefined
  formState.uc_tag = undefined
  formState.uc_role_tag = undefined
  formState.uc_plot_tag = undefined
  formState.uc_style_tag = undefined
  formState.uc_is_free = undefined
  formState.uc_publish = 0
  formState.uc_copyright_certificate_list = []
}

function fillForm(record) {
  formState.uc_type = record.uc_type || undefined
  formState.uc_tag = record.uc_tag || undefined
  formState.uc_role_tag = record.uc_role_tag || undefined
  formState.uc_plot_tag = record.uc_plot_tag || undefined
  formState.uc_style_tag = record.uc_style_tag || undefined
  formState.uc_is_free = record.uc_is_free || undefined
  formState.uc_publish = record.uc_publish !== undefined && record.uc_publish !== null ? record.uc_publish : 0
  formState.uc_copyright_certificate_list = urlsToFileList(record.uc_copyright_certificate)
}

// ========================= 暴露方法 =========================
function show(record) {
  currentRecord = record
  resetForm()
  visible.value = true
  getDetail(record.id)
}

defineExpose({ show })

// ========================= 事件处理 =========================
function touchOk() {
  RefForm.value?.validate().then(() => {
    const uploading = formState.uc_copyright_certificate_list.some(f => f.status === 'uploading')
    if (uploading) {
      message.warning('文件上传中，请稍候再提交')
      return
    }
    submitSave()
  }).catch(() => {})
}

function touchCancel() {
  visible.value = false
}

function touchDeleteFile(index) {
  formState.uc_copyright_certificate_list.splice(index, 1)
  RefForm.value?.validateFields(['uc_copyright_certificate_list']).catch(() => {})
}

function validatorCertificate(_, value) {
  const list = formState.uc_copyright_certificate_list.filter(f => f.status === 'done' && f.url)
  if (!list.length) {
    return Promise.reject('请上传版权证明文件')
  }
  return Promise.resolve()
}

function uploadResult(fileJson) {
  // Upload 组件上传完成后自动更新 fileList（fileJson.status 变为 done，url 为上传后的地址）
}

// ========================= 接口 =========================
function getDetail(id) {
  isDetailLoading.value = true
  thirdDramaDetail({ id, type: 'uc' }).then(res => {
    isDetailLoading.value = false
    const { code, data } = res
    if (code === 0 && data) {
      fillForm(data)
    } else {
      message.error(res.msg || res.message || '获取详情失败')
    }
  }).catch(() => {
    isDetailLoading.value = false
    message.error('获取详情失败')
  })
}

function submitSave() {
  isLoading.value = true
  const params = {
    drama_id: currentRecord?.id,
    uc_type: formState.uc_type,
    uc_tag: formState.uc_tag,
    uc_role_tag: formState.uc_role_tag,
    uc_plot_tag: formState.uc_plot_tag,
    uc_style_tag: formState.uc_style_tag,
    uc_is_free: formState.uc_is_free,
    uc_publish: formState.uc_publish,
    uc_copyright_certificate: formState.uc_copyright_certificate_list
      .filter(f => f.status === 'done' && f.url)
      .map(f => f.url)
  }
  ucSave(params).then(res => {
    isLoading.value = false
    if (res.code === 0) {
      message.success('保存成功')
      visible.value = false
      emit('success')
    } else {
      message.error(res.msg || res.message || '保存失败')
    }
  }).catch(() => {
    isLoading.value = false
    message.error('保存失败')
  })
}
</script>
